<!--C2-迭代需求 #42892（分期计算器H5设计）-->
<template>
  <div v-show="popVisible" class="popup" @click="stop($event)">
    <transition name="fade">
      <div class="popup-box" v-show="visible" @click="close($event)"></div>
    </transition>
    <transition name="bounce">
      <div class="popup-content" v-show="visible" @click="stop($event)">
        <slot>
          <!-- 插槽 -->
        </slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popVisible: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.popVisible = newVal;
          }, 300);
        } else {
          this.popVisible = newVal;
        }
      },
    },
  },
  methods: {
    close(e) {
      e && e.stopPropagation();
      this.$emit("close", false);
    },
    stop(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style scoped>
.popup {
  width: 7.5rem;
  height: 100%;
  position: fixed;
  z-index: 997;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: -moz-box;
  /* Firefox */
  display: -ms-flexbox;
  /* IE10 */
  display: -webkit-box;
  /* Safari */
  display: -webkit-flex;
  /* Chrome, WebKit */
  display: box;
  display: flexbox;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.popup > .popup-box {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.12);
  flex-direction: column;
  justify-content: flex-end;
}

.popup > .popup-content {
  width: 100%;
  position: relative;
  z-index: 2;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fade-enter-active {
  animation: fadeIn 0.3s;
}

.fade-leave-active {
  animation: fadeOut 0.3s;
}

.bounce-enter-active {
  animation: fadeInUp 0.3s;
}

.bounce-leave-active {
  animation: fadeOutDown 0.3s;
}
</style>


// WEBPACK FOOTER //
// src/components/VcarCalculator/components/VcarPopup.vue